var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4594 44.8875C34.0452 44.3015 34.3743 43.5068 34.3743 42.6781C34.3743 41.8495 34.0452 41.0548 33.4594 40.4688L17.9906 25L33.4594 9.53125C34.0286 8.94187 34.3436 8.15249 34.3365 7.33312C34.3294 6.51375 34.0007 5.72997 33.4213 5.15056C32.8419 4.57116 32.0581 4.24251 31.2388 4.23539C30.4194 4.22827 29.63 4.54326 29.0406 5.1125L11.3625 22.7906C10.7767 23.3766 10.4475 24.1714 10.4475 25C10.4475 25.8286 10.7767 26.6234 11.3625 27.2094L29.0406 44.8875C29.6266 45.4733 30.4214 45.8025 31.25 45.8025C32.0786 45.8025 32.8733 45.4733 33.4594 44.8875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4594 44.8875C34.0452 44.3015 34.3743 43.5068 34.3743 42.6781C34.3743 41.8495 34.0452 41.0548 33.4594 40.4688L17.9906 25L33.4594 9.53125C34.0286 8.94187 34.3436 8.15249 34.3365 7.33312C34.3294 6.51375 34.0007 5.72997 33.4213 5.15056C32.8419 4.57116 32.0581 4.24251 31.2388 4.23539C30.4194 4.22827 29.63 4.54326 29.0406 5.1125L11.3625 22.7906C10.7767 23.3766 10.4475 24.1714 10.4475 25C10.4475 25.8286 10.7767 26.6234 11.3625 27.2094L29.0406 44.8875C29.6266 45.4733 30.4214 45.8025 31.25 45.8025C32.0786 45.8025 32.8733 45.4733 33.4594 44.8875Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.47651ef414a23af9e9b466e0407216bd.svg";
export { ForwardRef as ReactComponent };